import { render, staticRenderFns } from "./OnlyPC.vue?vue&type=template&id=48c72baf&scoped=true&"
import script from "./OnlyPC.vue?vue&type=script&lang=js&"
export * from "./OnlyPC.vue?vue&type=script&lang=js&"
import style0 from "./OnlyPC.vue?vue&type=style&index=0&id=48c72baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c72baf",
  null
  
)

export default component.exports